import React, { useContext } from 'react';
import { useDispatchUpdatePortfolioSummaryVisibleColumns } from '../store/instances/configuration/dispatcher';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';
import AppContext from 'app/AppContext';
import { usePortfolioSummaryConfigurationSelector } from '../store/instances/configuration/selectors';
import { initialPortfolioSummaryConfiguration } from '../store/instances/configuration/PortfolioSummaryConfigurationState';
import {
    PortfolioSummaryColumn,
    portfolioSummaryColumnDefinitions,
} from '../grid/portfolioSummaryGridColumns';
import { getAggregationFieldHeaderText } from '../aggregation/fields/aggregationFieldDropdownItems';
import { AggregationField } from '../aggregation/fields/aggregationFieldPortfolio';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface PortfolioSummaryColumnPickerProps {
    aggregationField: AggregationField;
}

export default function PortfolioSummaryColumnPicker(
    props: PortfolioSummaryColumnPickerProps
) {
    const { aggregationField } = props;
    const appContext = useContext(AppContext);
    const { currencyFormat } = appContext;

    const { visibleColumns } = usePortfolioSummaryConfigurationSelector();
    const { editedColumnNames } = useWidgetEditedColumnNames();

    const headerText = getAggregationFieldHeaderText(
        aggregationField,
        currencyFormat
    );

    const columnDefs = portfolioSummaryColumnDefinitions(
        appContext,
        headerText,
        aggregationField
    );

    const allPickableItems: PickableItem<PortfolioSummaryColumn>[] =
        columnDefs.map((column) => ({
            value: column.colId! as PortfolioSummaryColumn,
            name:
                aggregationField === 'side' && column.colId === 'groupName'
                    ? 'Side'
                    : (editedColumnNames ?? {})[column.colId!] ??
                      column.headerName!,
            nameSuffix: (editedColumnNames ?? {})[column.colId!]
                ? column.headerName
                : undefined,
        }));

    const dispatchUpdateVisibleColumns =
        useDispatchUpdatePortfolioSummaryVisibleColumns();

    const onUpdateVisibleColumns = (cols: PortfolioSummaryColumn[]) => {
        dispatchUpdateVisibleColumns(cols);
    };

    // noinspection RequiredAttributes
    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={
                initialPortfolioSummaryConfiguration.visibleColumns
            }
            allItems={allPickableItems}
            hideGroupView={true}
            withoutDescriptions={true}
            onUpdateSelectedValues={onUpdateVisibleColumns}
        />
    );
}
